import React from 'react';

const TextArea = ({
  handleChange,
  placeholder = 'Placeholder Text',
  label = '',
  name,
  onBlur,
  className = '',
  validationMessage = null,
  value,
  disabled = false,
  validationError,
}) => {
  const onChange = (e) => {
    if (handleChange instanceof Function) handleChange(e.target.value);
  };

  return (
    <>
      <label
        className={`u-weight--semibold ${
          !label.length && label.length < 1 ? 'u-hidden' : ''
        }`}
        htmlFor={name}
      >
        {label || name}
      </label>

      <textarea
        className={`${
          validationError ? 'error' : ''
        } ${className} c-form__input c-form__input--secondary`}
        id={name}
        name={name}
        placeholder={placeholder}
        rows="7"
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        disabled={disabled}
      />

      {validationError && (
        <p className="c-form__error u-weight--semibold u-mb-0">
          {validationMessage}
        </p>
      )}
    </>
  );
};

export default TextArea;
